import { Box, useTheme } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { Autoclave, SporetestingResult, SporetestLog, SporetestLogRow } from '../../types'
import { useEffect, useState } from 'react'
import { Biobox, TeamMember } from '../../../../../types'
import { getSporetestLogRows } from '../../utils/helpers'
import { textTransform } from 'html2canvas/dist/types/css/property-descriptors/text-transform'

type SporetestLogTable = {
  autoclave: Autoclave,
  bioboxesById: Map<number, Biobox>,
  sporetestsById: Map<number, SporetestingResult>,
  sporetestLogsByAutoclaveId: Map<number, SporetestLog[]>,
  usersById: Map<number, TeamMember>,
}

const SporetestLogTable = (props: SporetestLogTable) => {
  const { autoclave, bioboxesById, sporetestsById, sporetestLogsByAutoclaveId, usersById } = props
  const theme = useTheme()
  
  const [ rows, setRows ] = useState<SporetestLogRow[]>([])

  const autoclaveId = Number(autoclave.autoclave_id)
  const sporetestLogs = sporetestLogsByAutoclaveId.get(autoclaveId) ?? []

  useEffect(() => {
    const rows = getSporetestLogRows(sporetestLogs, bioboxesById, sporetestsById, usersById)
    setRows(rows)
  }, [sporetestLogs])

  return (
    <DataGrid
      sx={{
        paddingLeft: '16px',
        paddingRight: '16px',
        borderLeft: 'none',
        borderRight: 'none',
        borderBottom: 'none',
        borderRadius: '0',
        color: theme.palette.color50555b.main,
      }}
      getRowId={(row) => row.id!}
      rows={rows}
      loading={sporetestLogs === null}
      pageSizeOptions={[5, 10, 20, 25, 50, 100]}
      columns={[
        {
          field: 'box_number',
          headerName: 'Box Number',
          sortable: true,
          flex: 1,
        },
        {
          field: 'test_number',
          headerName: 'Test Number',
          sortable: true,
          flex: 1,
        },
        {
          field: 'test_date',
          headerName: 'Test Date',
          sortable: true,
          flex: 1,
          valueGetter: (value, row) => {
            return row.sample_date.valueOf()
          },
          renderCell: (params) => {
            const { sample_date } = params.row
            return sample_date.format('MM/DD/YYYY')
          }
        },
        {
          field: 'test_operator',
          headerName: 'Operator',
          sortable: true,
          flex: 1,
        },
        {
          field: 'created_at',
          headerName: 'Timestamp',
          sortable: true,
          flex: 1,
          valueGetter: (value, row) => {
            return row.created_at.valueOf()
          },          
          renderCell: (params) => {
            const { created_at } = params.row
            return created_at.format('MM/DD/YYYY')
          }
        },
        {
          field: 'user_name',
          headerName: 'User',
          sortable: true,
          flex: 1,
        },
        {
          field: 'action',
          headerName: 'Action',
          sortable: true,
          flex: 1,
          renderCell: (params) => {
            return (
              <Box sx={{ textTransform: 'capitalize' }}>
                { params.row.action }
              </Box>
            )
          }
        },
      ]}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10
          }
        },
        sorting: {
          sortModel: [
            {
              field: 'created_at',
              sort: 'desc'
            }
          ]
        }
      }}
    />
  )
}

export default SporetestLogTable
